import React, { type FC } from 'react';
import * as SelectPrimitive from '@radix-ui/react-select';
import { CaretDown } from 'phosphor-react';
import { cn } from '../../../lib';

export const SelectTrigger: FC<SelectPrimitive.SelectTriggerProps> = (props) => {
  const { className, children, ...rest } = props;

  return (
    <SelectPrimitive.Trigger className={cn('disabled:cursor-not-allowed', className)} {...rest}>
      <span className='flex flex-row items-center justify-between gap-1'>
        <span className='flex-1 text-left [&>span]:line-clamp-1'>{children}</span>

        <SelectPrimitive.Icon asChild>
          <CaretDown className='h-3 w-3' />
        </SelectPrimitive.Icon>
      </span>
    </SelectPrimitive.Trigger>
  );
};
